import { FocusContext } from '@noriginmedia/norigin-spatial-navigation'
import React, { memo, useCallback, useState } from 'react'
import { useHybridFocusable } from '../../hooks/useHybridFocusable'
import KeyboardKeys from './KeyboardKeys'
import KeyboardDistributionToggler from './KeyboardToggler'
import type { KeyboardProps } from './types'
import {
  AlphaCollection,
  KeyBoardDistributionEnum,
  NumericCollection,
} from './types'

const KEYBOARD_COMPONENT_FOCUS_KEY = 'KEYBOARD_COMPONENT'

const Keyboard = ({
  onEnterPress: onEnterPressProps,
  keyBoardDistribution:
    initialKeyBoardDistribution = KeyBoardDistributionEnum.alpha,
  allowSpaces = true,
  allowDelete = true,
  onArrowPress,
  stealFocus,
}: KeyboardProps) => {
  const { ref, focusKey } = useHybridFocusable({
    focusKey: KEYBOARD_COMPONENT_FOCUS_KEY,
  })
  const [keyBoardDistribution, setKeyBoardDistribution] = useState(
    initialKeyBoardDistribution
  )

  const onKeyEnterPress = useCallback(
    (props: { keyString: AlphaCollection | NumericCollection }) => {
      onEnterPressProps(props.keyString)
    },
    [onEnterPressProps]
  )

  const onKeyboardToggleEnterPress = useCallback(
    (keyboardType: KeyBoardDistributionEnum) => {
      setKeyBoardDistribution(keyboardType)
    },
    [setKeyBoardDistribution]
  )

  return (
    <FocusContext.Provider value={focusKey}>
      <div ref={ref}>
        {initialKeyBoardDistribution === KeyBoardDistributionEnum.alpha && (
          <KeyboardDistributionToggler
            onEnterPress={onKeyboardToggleEnterPress}
          />
        )}
        <KeyboardKeys
          onArrowPress={onArrowPress}
          keyboardDistributionKey={keyBoardDistribution}
          onEnterPress={onKeyEnterPress}
          allowSpaces={allowSpaces}
          allowDelete={allowDelete}
          stealFocus={stealFocus}
        />
      </div>
    </FocusContext.Provider>
  )
}

export default memo(Keyboard)
